import { Divider, Typography, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import BoldHeading from "../components/BoldHeading";
import Section from "../components/Section";
import SideContent from "../components/SideContent";
import core1 from "../images/NewUI/core1.png";
import core2 from "../images/NewUI/core2.png";
import core3 from "../images/NewUI/core3.png";
import core4 from "../images/NewUI/core4.png";
import core5 from "../images/NewUI/core5.png";
import core6 from "../images/NewUI/core6.png";

const CoreSection = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <>
      <Section pb="0">
        <div className="p-relative" style={{ zIndex: 1 }}>
          <BoldHeading>Core</BoldHeading>
          <Typography variant="h2" lineHeight={1} mb={1.5}>
            Structures
          </Typography>
          <Typography variant="h4" lineHeight={1} fontWeight="normal">
            of SIX Protocol
          </Typography>
        </div>

        <Box
          className={`d-flex align-start flex-wrap ${
            !md ? "flex-column-reverse" : ""
          }`}
          mt={10}
        >
          <SideContent isLarge>
            <Typography
              variant="subtitle1"
              lineHeight={1}
              mb={1.5}
              fontWeight="800"
            >
              SIX Protocol - Toolkits
            </Typography>
            <Typography variant="h4" lineHeight={1}>
              Web 3.0 Integration
            </Typography>
            <Divider
              sx={{
                borderTop: "1px dashed rgba(255,255,255,0.5)",
                mt: 2,
                mb: 1.5,
              }}
            />
            <Typography>
              Prepare for the full-fledged decentralized world in Web3 era via
              connection to the blockchain system and decentralized wallets.
            </Typography>
          </SideContent>
          <SideContent>
            <img
              src={core1}
              alt=""
              width={lg ? "70%" : md ? "100%" : sm ? "40%" : "60%"}
              style={{ maxWidth: "initial" }}
            />
          </SideContent>
        </Box>
      </Section>

      <Section containerClass="d-flex align-center flex-wrap" pb={md ? 4 : "0"}>
        <SideContent>
          <img
            src={core2}
            alt=""
            width={lg ? "70%" : md ? "100%" : sm ? "40%" : "60%"}
            style={{ maxWidth: "initial" }}
          />
        </SideContent>
        <SideContent isLarge isRight>
          <Typography
            variant="subtitle1"
            lineHeight={1}
            mb={1.5}
            fontWeight="800"
          >
            SIX Protocol - Toolkits
          </Typography>
          <Typography variant="h4" lineHeight={1}>
            Token Autonomy Management
          </Typography>
          <Divider
            sx={{
              borderTop: "1px dashed rgba(255,255,255,0.5)",
              mt: 2,
              mb: 1.5,
            }}
          />
          <Typography>
            Create and manage your own token with a unique cross-chain
            technology in the form of cryptocurrency or NFTs through the
            combination of IDO and INO for businesses under the Initial Asset
            Offering (IAO) service.
          </Typography>
        </SideContent>
      </Section>

      <Section
        containerClass={`d-flex align-center flex-wrap ${
          !md ? "flex-column-reverse" : ""
        }`}
        pb={md ? 4 : "0"}
      >
        <SideContent isLarge>
          <Typography
            variant="subtitle1"
            lineHeight={1}
            mb={1.5}
            fontWeight="800"
          >
            SIX Token
          </Typography>
          <Typography variant="h4" lineHeight={1}>
            The Fuel of SIX Protocol
          </Typography>
          <Divider
            sx={{
              borderTop: "1px dashed rgba(255,255,255,0.5)",
              mt: 2,
              mb: 1.5,
            }}
          />
          <Typography>
            SIX token is a cryptocurrency of SIX Network that plays an important
            role. SIX is used for spending as a transactional fee, governing the
            system, and redeeming the services on SIX Protocol.
          </Typography>
        </SideContent>
        <SideContent>
          <img
            src={core3}
            alt=""
            width={lg ? "70%" : md ? "100%" : sm ? "40%" : "60%"}
            style={{ maxWidth: "initial" }}
          />
        </SideContent>
      </Section>

      <Section containerClass="d-flex align-center flex-wrap" pb={md ? 4 : "0"}>
        <SideContent>
          <img
            src={core4}
            alt=""
            width={lg ? "70%" : md ? "100%" : sm ? "40%" : "60%"}
            style={{ maxWidth: "initial" }}
          />
        </SideContent>
        <SideContent isLarge isRight>
          <Typography
            variant="subtitle1"
            lineHeight={1}
            mb={1.5}
            fontWeight="800"
          >
            SIX Protocol - Toolkits
          </Typography>
          <Typography variant="h4" lineHeight={1}>
            Business Tokenization
          </Typography>
          <Divider
            sx={{
              borderTop: "1px dashed rgba(255,255,255,0.5)",
              mt: 2,
              mb: 1.5,
            }}
          />
          <Typography maxWidth="92%">
            Bringing businesses to the blockchain by converting off-chain to
            on-chain digital assets.
          </Typography>
        </SideContent>
      </Section>

      <Section
        containerClass={`d-flex align-center flex-wrap ${
          !md ? "flex-column-reverse" : ""
        }`}
        pb={md ? 4 : "0"}
      >
        <SideContent isLarge>
          <Typography
            variant="subtitle1"
            lineHeight={1}
            mb={1.5}
            fontWeight="800"
          >
            SIX Protocol - Toolkits
          </Typography>
          <Typography variant="h4" lineHeight={1}>
            NFT Gen 2
          </Typography>
          <Divider
            sx={{
              borderTop: "1px dashed rgba(255,255,255,0.5)",
              mt: 2,
              mb: 1.5,
            }}
          />
          <Typography>
            Taking NFTs to another level with NFT Gen 2, the dynamic data layer
            that runs on the SIX Protocol, allows tracking and tracing of any
            NFT usage for utilities and privileges management.
          </Typography>
        </SideContent>
        <SideContent>
          <img
            src={core5}
            alt=""
            width={lg ? "70%" : md ? "100%" : sm ? "40%" : "60%"}
            style={{ maxWidth: "initial" }}
          />
        </SideContent>
      </Section>

      <Section containerClass="d-flex align-center flex-wrap">
        <SideContent>
          <img
            src={core6}
            alt=""
            width={lg ? "70%" : md ? "100%" : sm ? "40%" : "60%"}
            style={{ maxWidth: "initial" }}
          />
        </SideContent>
        <SideContent isLarge isRight>
          <Typography
            variant="subtitle1"
            lineHeight={1}
            mb={1.5}
            fontWeight="800"
          >
            SIX Protocol
          </Typography>
          <Typography variant="h4" lineHeight={1}>
            Blockchain
          </Typography>
          <Divider
            sx={{
              borderTop: "1px dashed rgba(255,255,255,0.5)",
              mt: 2,
              mb: 1.5,
            }}
          />

          <Typography>
            SIX Protocol Chain is the most important part of the protocol,
            driven by the Proof of Stake consensus mechanism. The protocol is
            operated by a group of validator nodes that are verified businesses.
          </Typography>
        </SideContent>
      </Section>
    </>
  );
};

export default CoreSection;
